import { render, staticRenderFns } from "./BaseSocialAccounts.vue?vue&type=template&id=5e62408a&"
import script from "./BaseSocialAccounts.vue?vue&type=script&lang=js&"
export * from "./BaseSocialAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BaseSocialAccounts.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports